import axiosInstance from "../../utils/AxiosInstance";

export interface OverviewCompany {
  id: string;
  name: string;
  officeCount: number;
  coachCount: number;
  applicantCount: number;
}

export interface OverviewTotals {
  companies: number;
  offices: number;
  coaches: number;
  applicants: number;
}

export interface Overview {
  companies: OverviewCompany[];
  totals: OverviewTotals;
}

export function getOverview(): Promise<Overview> {
  return axiosInstance.get<Overview>("/overview").then((response) => response.data);
}
